/**
 * Error reporting for the game client (Phase 9, ADR-0005): the shared Sentry-protocol
 * reporter, pointed at `VITE_PUBLIC_SENTRY_DSN` (empty = off), labelled with the git short
 * hash the build baked in. Nothing personal is attached to an event.
 */
import { createErrorReporter } from '@steelwake/shared/telemetry';

export const reporter = createErrorReporter({
  dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
  app: 'web',
  platform: 'javascript',
  release: import.meta.env.VITE_PUBLIC_RELEASE,
  environment: import.meta.env.MODE,
  onFailure: (message) => console.warn(`[telemetry] ${message}`),
});

let installed = false;

/** Reports what nothing else caught: uncaught errors and unhandled promise rejections. */
export function installErrorReporting(): void {
  if (installed) return;
  installed = true;
  window.addEventListener('error', (event) => {
    reporter.capture(event.error ?? event.message, {
      handled: false,
      tags: { mechanism: 'onerror' },
    });
  });
  window.addEventListener('unhandledrejection', (event) => {
    reporter.capture(event.reason, { handled: false, tags: { mechanism: 'unhandledrejection' } });
  });
}
